module.exports = __webpack_public_path__ + "img/detail-02_2.668fc5bf.png";